import { activateOptimizelyExperiment, setOptimizelyTriggeredCookie } from 'lib/optimizely/optimizelyUtils'
import { SET_OPTIMIZELY_EXPERIMENT, SET_OPTIMIZELY_FEATURE_FLAG } from './actionConstants'
import config from 'constants/config'
import * as Analytics from 'analytics/analytics'
import { activateCampaignEvent } from 'analytics/snowplow/events'
import { OptimizelyExperiments, OptimizelyFeatureFlags } from 'constants/optimizely'

export function setOptimizelyExperiment(flagKey: OptimizelyExperiments) {
  return async(dispatch, getState) => {
    const state = getState() as App.State
    const experimentState = state.optimizely.optimizelyExperiments[flagKey]
    const experimentValues = await activateOptimizelyExperiment(flagKey)
    if (experimentState && experimentValues) {
      const variationId = experimentState.variation?.[experimentState.variationKey]

      if (experimentValues.triggered) {
        setOptimizelyTriggeredCookie(flagKey)
      }

      if (
        !!variationId &&
        experimentState.campaignId &&
        experimentState.experimentId &&
        !experimentState.triggered &&
        !config.OPTIMIZELY_TRIGGER_REPORT
      ) {
        Analytics.trackEvent(activateCampaignEvent(
          experimentState.campaignId,
          experimentState.experimentId,
          variationId,
        ))
      }

      if (
        experimentState.variationKey !== experimentValues.variationKey ||
        experimentState.triggered !== experimentValues.triggered
      ) {
        dispatch({
          type: SET_OPTIMIZELY_EXPERIMENT,
          flagKey,
          value: experimentValues,
        })
      }
    }
  }
}

export function setOptimizelyFeatureFlag(flagKey: OptimizelyFeatureFlags) {
  return async(dispatch, getState) => {
    const state = getState() as App.State
    const experimentValues = await activateOptimizelyExperiment(flagKey)

    if (state.optimizely.optimizelyFeatureFlags[flagKey] !== experimentValues?.enabled) {
      dispatch({
        type: SET_OPTIMIZELY_FEATURE_FLAG,
        flagKey,
        value: experimentValues?.enabled,
      })
    }
  }
}
